// AI-assisted: Claude 2026-08-08, human-reviewed: ausstehend
// Kurze Einführung nach dem ersten Anmelden (Thors Wunsch Runde 16).
// Fünf Karten, jede erklärt genau einen Knopf der unteren Leiste — und die
// letzte setzt die Person dort ab, wo es losgeht: bei der Plan-Auswahl.
// Überspringen steht immer sichtbar da; niemand wird festgehalten.
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { einfuehrungMerken } from "@/lib/einfuehrung"
import { IconHantel, IconPlan, IconSpross, IconStift } from "./icons"
import Fuchs from "./celebration/creatures/Fuchs"
import "@/styles/einfuehrung.css"

interface Schritt {
  titel: string
  text: string
  bild: React.ReactNode
}

const SCHRITTE: Schritt[] = [
  {
    titel: "Willkommen bei fitHub",
    text: "Dein Trainingsbuch. Es läuft auf unserem eigenen Server — deine Sätze, "
      + "Gewichte und dein Körpergewicht sieht niemand außer dir.",
    bild: <Fuchs />,
  },
  {
    titel: "Such dir einen Plan",
    text: "Unter Plan liegen fertige Vorlagen. Ganz oben stehen drei Vorschläge "
      + "für den Anfang, darunter alles nach Sportart sortiert. Umbauen darfst du jeden.",
    bild: <IconPlan size={54} />,
  },
  {
    titel: "Training führt dich durch",
    text: "Der grüne Knopf in der Mitte startet den Tag: Übung für Übung, mit Pause "
      + "dazwischen. Gerät belegt? Übung zur Seite wischen — sie kommt später wieder.",
    bild: <IconHantel size={54} />,
  },
  {
    titel: "Oder trag einzeln nach",
    text: "Spontan trainiert? „Satz nachtragen\" auf der Startseite — Wiederholungen "
      + "und Gewicht in unter zehn Sekunden getippt. Ohne Netz auch, es geht später von selbst raus.",
    bild: <IconStift size={54} />,
  },
  {
    titel: "Und dann wächst was",
    text: "Unter Fortschritt steht deine Pflanze. Sie wächst mit jeder Einheit und "
      + "schrumpft nie — Pausen sind erlaubt, das Leben kommt dazwischen.",
    bild: <IconSpross size={54} />,
  },
]

export default function Einfuehrung({ onFertig }: { onFertig: () => void }) {
  const navigate = useNavigate()
  const [i, setI] = useState(0)
  const letzte = i === SCHRITTE.length - 1
  const s = SCHRITTE[i]

  function schliessen(zumPlan: boolean) {
    einfuehrungMerken()
    onFertig()
    if (zumPlan) navigate("/plaene")
  }

  return (
    <div className="ein-hinter" role="dialog" aria-modal="true" aria-label="Einführung">
      <div className="ein-karte" key={i}>
        <div className="ein-bild" aria-hidden="true">{s.bild}</div>
        <h2 className="ein-titel">{s.titel}</h2>
        <p className="ein-text">{s.text}</p>

        <div className="ein-punkte" aria-hidden="true">
          {SCHRITTE.map((_, n) => <i key={n} className={n === i ? "an" : ""} />)}
        </div>

        <button type="button" className="save pressable ein-weiter"
          onClick={() => (letzte ? schliessen(true) : setI(i + 1))}>
          {letzte ? "Plan aussuchen" : "Weiter"}
        </button>
        <button type="button" className="ein-ueber" onClick={() => schliessen(false)}>
          {letzte ? "Später aussuchen" : "Überspringen"}
        </button>
      </div>
    </div>
  )
}
